import React from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';


/**
 * MenuToggleButton Component.
 * For smaller devices (700 pixels and less)
 * 
 * Function component that holds the "Menu" and "Close" buttons used in the NavBar
 * component
 * 
 * @param {*} props  The properties passed from its parent component (NavBar)
 */
function MenuToggleButton(props) {

   return (
      <div className="bars" onClick={props.clickHandler}>
         <i>{props.clicked ? <FaTimes style={{color:'#5171a5', backgroundColor:'white'}}/> : <FaBars />}</i>
      </div>
   )
}

export default MenuToggleButton;